(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9878],{

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomMetaHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CustomMetaHead(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [meta.title, " | ", "SUPERMARKET Κρητικός"]
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: meta.keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "index, follow"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:title",
      content: "".concat(meta.title, " | ").concat("SUPERMARKET Κρητικός")
    }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:url",
      content: meta.url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image",
      content: meta.image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:width",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:height",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:alt",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:site_name",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "canonical",
      content: meta.url
    })]
  });
}

/***/ }),

/***/ 54196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DeliveryBanner_DeliveryBanner; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
var distinctUntilChanged = __webpack_require__(41931);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/isAddressRegistered.js
var store_isAddressRegistered = __webpack_require__(19094);
// EXTERNAL MODULE: ./src/store/serviceInfo.js
var serviceInfo = __webpack_require__(65737);
// EXTERNAL MODULE: ./src/store/shop.js
var shop = __webpack_require__(99777);
// EXTERNAL MODULE: ./src/store/user.js
var user = __webpack_require__(73471);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/api/Shops.js + 1 modules
var Shops = __webpack_require__(71432);
// EXTERNAL MODULE: ./src/utils/dayjs.js
var dayjs = __webpack_require__(95286);
// EXTERNAL MODULE: ./src/store/timeslots.js
var store_timeslots = __webpack_require__(81786);
;// CONCATENATED MODULE: ./src/utils/timeslots.js




function getOrFetchTakeAwayTimeSlots(shop) {
  if (store_timeslots/* TakeAwayTimeslotsStore.isFetched */.dX.isFetched()) {
    return store_timeslots/* TakeAwayTimeslotsStore.getValue */.dX.getValue();
  }

  return updateTakeAwayTimeslots(shop);
}
function updateTakeAwayTimeslots(_x) {
  return _updateTakeAwayTimeslots.apply(this, arguments);
}

function _updateTakeAwayTimeslots() {
  _updateTakeAwayTimeslots = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(shop) {
    var timeslots;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,Shops/* getTimeslotsForTakeAwayShop */.L9)(shop);

          case 2:
            timeslots = _context.sent;
            store_timeslots/* TakeAwayTimeslotsStore.update */.dX.update(timeslots);
            return _context.abrupt("return", timeslots);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateTakeAwayTimeslots.apply(this, arguments);
}

function getOrFetchExpressTimeSlots(postalCode) {
  if (store_timeslots/* ExpressTimeslotsStore.isFetched */.Ku.isFetched()) {
    return store_timeslots/* ExpressTimeslotsStore.getValue */.Ku.getValue();
  }

  return updateExpressTimeslots(postalCode);
}
function updateExpressTimeslots(_x2) {
  return _updateExpressTimeslots.apply(this, arguments);
}

function _updateExpressTimeslots() {
  _updateExpressTimeslots = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(postalCode) {
    var timeslots;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0,Shops/* getTimeslots */.rS)(postalCode);

          case 2:
            timeslots = _context2.sent;
            store_timeslots/* ExpressTimeslotsStore.update */.Ku.update(timeslots);
            return _context2.abrupt("return", timeslots);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateExpressTimeslots.apply(this, arguments);
}

/* harmony default export */ var timeslots = ({
  getOrFetchTakeAwayTimeSlots: getOrFetchTakeAwayTimeSlots,
  getOrFetchExpressTimeSlots: getOrFetchExpressTimeSlots,
  updateTakeAwayTimeslots: updateTakeAwayTimeslots
});
;// CONCATENATED MODULE: ./src/utils/expressMode.js







var NOT_SUPPORTED_REGION_TEXT = 'Δυστυχώς η περιοχή σου δεν καλύπτεται ακόμα';

function getEasyTimeslotsData(shops) {
  if (shops.error) {
    return [undefined, NOT_SUPPORTED_REGION_TEXT];
  }

  var timeslots = get_default()(shops, '[0].timeSlots', []);
  var slot = timeslots.find(function (t) {
    return t.isAvailable;
  });

  if (!slot) {
    var _easyDeliverySlotsText = 'Δεν υπάρχουν διαθέσιμες ώρες παράδοσης.';
    return [shops, _easyDeliverySlotsText];
  }

  var start = (0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'dddd, DD/MM, HH:mm');
  var end = (0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm');
  var easyDeliverySlotsText = "\u03A4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF, ".concat(start, " - ").concat(end);
  return [shops, easyDeliverySlotsText];
}

function getExpressTimeslotsData(data) {
  var _data$extraInfo;

  if (!(data !== null && data !== void 0 && (_data$extraInfo = data.extraInfo) !== null && _data$extraInfo !== void 0 && _data$extraInfo.deliversPostalCode)) {
    return [data, NOT_SUPPORTED_REGION_TEXT];
  }

  var timeslots = get_default()(data, 'timeslots', []);
  var slot = timeslots.find(function (t) {
    return t.isAvailable;
  });

  if (!slot) {
    var _expressDeliverySlotsText = 'Είμαστε πλήρεις, ραντεβού ξανά το πρωί!';
    return [data, _expressDeliverySlotsText];
  }

  var start = (0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'dddd, DD/MM, HH:mm');
  var end = (0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm');
  var expressDeliverySlotsText = "\u03A4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF, ".concat(start, " - ").concat(end);
  return [data, expressDeliverySlotsText];
}

function fetchTimeslots(_x) {
  return _fetchTimeslots.apply(this, arguments);
}

function _fetchTimeslots() {
  _fetchTimeslots = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(postalCode) {
    var shops, _getEasyTimeslotsData, _getEasyTimeslotsData2, easyTimeslots, easyMessage, expressData, _getExpressTimeslotsD, _getExpressTimeslotsD2, expressTimeslots, exprxessMessage;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,Shops/* getByPostalCode */.r4)(postalCode);

          case 2:
            shops = _context.sent;
            _getEasyTimeslotsData = getEasyTimeslotsData(shops), _getEasyTimeslotsData2 = (0,slicedToArray/* default */.Z)(_getEasyTimeslotsData, 2), easyTimeslots = _getEasyTimeslotsData2[0], easyMessage = _getEasyTimeslotsData2[1];
            _context.next = 6;
            return getOrFetchExpressTimeSlots(postalCode);

          case 6:
            expressData = _context.sent;
            _getExpressTimeslotsD = getExpressTimeslotsData(expressData), _getExpressTimeslotsD2 = (0,slicedToArray/* default */.Z)(_getExpressTimeslotsD, 2), expressTimeslots = _getExpressTimeslotsD2[0], exprxessMessage = _getExpressTimeslotsD2[1];
            return _context.abrupt("return", [easyTimeslots, easyMessage, expressTimeslots, exprxessMessage]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchTimeslots.apply(this, arguments);
}

function getTakeAwayMessage(timeSlots) {
  var noAvailableTimeSlotsTakeAway = 'Δεν υπάρχουν διαθέσιμες ώρες παράδοσης.';
  if (!timeSlots) return noAvailableTimeSlotsTakeAway;
  var firstAvaiableTimeslot = timeSlots.find(function (t) {
    return t.isAvailable;
  });
  if (!firstAvaiableTimeslot) return noAvailableTimeSlotsTakeAway;
  var start = (0,dayjs/* formatUnixDate */.WE)(firstAvaiableTimeslot.timeSlotStart, 'dddd, DD/MM, HH:mm');
  var end = (0,dayjs/* formatUnixDate */.WE)(firstAvaiableTimeslot.timeSlotEnd, 'HH:mm');
  var takeAwayDeliverySlotsText = "\u03A4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF, ".concat(start, " - ").concat(end);
  return takeAwayDeliverySlotsText;
}
/* harmony default export */ var expressMode = ({
  fetchTimeslots: fetchTimeslots,
  getTakeAwayMessage: getTakeAwayMessage
});
// EXTERNAL MODULE: ./src/utils/modalStyle.js
var modalStyle = __webpack_require__(13764);
// EXTERNAL MODULE: ./src/components/DeliveryBanner/DeliveryBanner.module.scss
var DeliveryBanner_module = __webpack_require__(54804);
var DeliveryBanner_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryBanner_module);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/Buttons/Buttons.jsx
var Buttons = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/components/DeliveryBanner/DeliveryPrompt.module.scss
var DeliveryPrompt_module = __webpack_require__(95821);
var DeliveryPrompt_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryPrompt_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/DeliveryBanner/DeliveryPrompt.jsx





function DeliveryPrompt(_ref) {
  var onClickButton = _ref.onClickButton;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DeliveryPrompt_module_default()).promptContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DeliveryPrompt_module_default()).instruction,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdLocationPin */.vcr, {
        className: (DeliveryPrompt_module_default()).icon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (DeliveryPrompt_module_default()).promptText,
        children: "\u03A0\u03B5\u03C2 \u03BC\u03B1\u03C2 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03AE \u03C3\u03BF\u03C5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03B9\u03C2 \u03BC\u03B5 \u03C0\u03BF\u03B9\u03B1 online \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B8\u03B1 \u03C3\u03B5 \u03B5\u03BE\u03C5\u03C0\u03B7\u03C1\u03B5\u03C4\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
      onClick: onClickButton,
      "data-cy": "coverage",
      children: "\u0394\u03B5\u03C2 \u03C0\u03CE\u03C2 \u03B5\u03BE\u03C5\u03C0\u03B7\u03C1\u03B5\u03C4\u03B5\u03AF\u03C3\u03B1\u03B9"
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/DeliveryBanner/DeliveryBanner.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var DeliveryBanner_NOT_SUPPORTED_REGION_TEXT = 'Δυστυχώς η περιοχή σου δεν καλύπτεται ακόμα';
var NOT_AVAILABLE_TIMESLOTS_TEXT = 'Δεν υπάρχουν διαθέσιμες ώρες παράδοσης.';
var FULL_CAPACITY_TIMESLOTS_TEXT = 'Είμαστε πλήρεις, ραντεβού ξανά το πρωί!';
var CheckAddressView = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(5642), __webpack_require__.e(4438)]).then(__webpack_require__.bind(__webpack_require__, 24439));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(24439)];
    }
  }
});
var DeliveryOptions = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(2013), __webpack_require__.e(3253), __webpack_require__.e(4099), __webpack_require__.e(6334)]).then(__webpack_require__.bind(__webpack_require__, 1464));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1464)];
    }
  }
});
var GenericModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(3253), __webpack_require__.e(9875)]).then(__webpack_require__.bind(__webpack_require__, 49875));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(49875)];
    }
  }
});

function DeliveryBanner() {
  var _useState = (0,react.useState)(),
      isAddressRegistered = _useState[0],
      setIsAddressRegistered = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCheckAddressModalOpen = _useState2[0],
      setIsCheckAddressModalOpen = _useState2[1];

  function fetchDeliveryMethods(_x) {
    return _fetchDeliveryMethods.apply(this, arguments);
  }

  function _fetchDeliveryMethods() {
    _fetchDeliveryMethods = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(postalCodeInput) {
      var _yield$fetchTimeslots, _yield$fetchTimeslots2, easyTimeslots, _easyMessage, expressTimeslots, _expressMessage;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchTimeslots(postalCodeInput);

            case 2:
              _yield$fetchTimeslots = _context3.sent;
              _yield$fetchTimeslots2 = (0,slicedToArray/* default */.Z)(_yield$fetchTimeslots, 4);
              easyTimeslots = _yield$fetchTimeslots2[0];
              _easyMessage = _yield$fetchTimeslots2[1];
              expressTimeslots = _yield$fetchTimeslots2[2];
              _expressMessage = _yield$fetchTimeslots2[3];
              serviceInfo/* default.setResExpress */.Z.setResExpress(expressTimeslots, _expressMessage);

              if (_expressMessage === DeliveryBanner_NOT_SUPPORTED_REGION_TEXT || _expressMessage === FULL_CAPACITY_TIMESLOTS_TEXT) {
                serviceInfo/* default.setValidAddressExpress */.Z.setValidAddressExpress(false);
              } else {
                serviceInfo/* default.setValidAddressExpress */.Z.setValidAddressExpress(true);
              }

              serviceInfo/* default.setResEasy */.Z.setResEasy(easyTimeslots, _easyMessage);

              if (_easyMessage === DeliveryBanner_NOT_SUPPORTED_REGION_TEXT || _easyMessage === NOT_AVAILABLE_TIMESLOTS_TEXT) {
                serviceInfo/* default.setValidAddressEasy */.Z.setValidAddressEasy(false);
              } else {
                serviceInfo/* default.setValidAddressEasy */.Z.setValidAddressEasy(true);
              }

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _fetchDeliveryMethods.apply(this, arguments);
  }

  function selectStore(_x2) {
    return _selectStore.apply(this, arguments);
  }

  function _selectStore() {
    _selectStore = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(store) {
      var _yield$updateTakeAway2, timeslots, takeAwayMsg, prevService, prevShop;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return updateTakeAwayTimeslots(store._id);

            case 2:
              _yield$updateTakeAway2 = _context4.sent;
              timeslots = _yield$updateTakeAway2.timeslots;
              takeAwayMsg = getTakeAwayMessage(timeslots);
              serviceInfo/* default.setResTakeAway */.Z.setResTakeAway(timeslots, takeAwayMsg);
              prevService = deliveryMode/* default.getValue */.Z.getValue();
              prevShop = shop/* Shop.getValue */.k3.getValue();
              cart/* ValuesToBeUpdated.updateService */.vV.updateService(prevService);
              cart/* ValuesToBeUpdated.updateShop */.vV.updateShop(prevShop === null || prevShop === void 0 ? void 0 : prevShop.takeAwayShop);
              shop/* Shop.setTakeAwayShop */.k3.setTakeAwayShop(store);
              deliveryMode/* default.update */.Z.update('takeAway');

              if (!(takeAwayMsg === NOT_AVAILABLE_TIMESLOTS_TEXT)) {
                _context4.next = 15;
                break;
              }

              serviceInfo/* default.setValidTakeAway */.Z.setValidTakeAway(false);
              return _context4.abrupt("return");

            case 15:
              serviceInfo/* default.setValidTakeAway */.Z.setValidTakeAway(true);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _selectStore.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    function fetchTimeslotsTakeAway() {
      return _fetchTimeslotsTakeAway.apply(this, arguments);
    }

    function _fetchTimeslotsTakeAway() {
      _fetchTimeslotsTakeAway = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var currentShop, _yield$updateTakeAway, timeslots, takeAwayMsg;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentShop = shop/* Shop.getValue */.k3.getValue();
                serviceInfo/* default.setValidTakeAway */.Z.setValidTakeAway(true);

                if (currentShop !== null && currentShop !== void 0 && currentShop.takeAwayShop) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return updateTakeAwayTimeslots(currentShop === null || currentShop === void 0 ? void 0 : currentShop.takeAwayShop._id);

              case 6:
                _yield$updateTakeAway = _context.sent;
                timeslots = _yield$updateTakeAway.timeslots;
                takeAwayMsg = getTakeAwayMessage(timeslots);
                serviceInfo/* default.setResTakeAway */.Z.setResTakeAway(timeslots, takeAwayMsg);

                if (takeAwayMsg === NOT_AVAILABLE_TIMESLOTS_TEXT) {
                  serviceInfo/* default.setValidTakeAway */.Z.setValidTakeAway(false);
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchTimeslotsTakeAway.apply(this, arguments);
    }

    fetchTimeslotsTakeAway();
  }, []);
  (0,react.useEffect)(function () {
    store_isAddressRegistered/* PostalCode.lazyInit */.Rr.lazyInit();
    var isCheckAddressModal$ = store_isAddressRegistered/* IsCheckAddressModal.subscribe */.eR.subscribe(setIsCheckAddressModalOpen);
    var isAddressRegistered$ = store_isAddressRegistered/* IsAddressRegistered.subscribe */.Zl.subscribe(function (hasRegisterAddress) {
      (0,react.startTransition)(function () {
        setIsAddressRegistered(hasRegisterAddress);
      });
    });
    var postalCode$ = store_isAddressRegistered/* PostalCode.subject.pipe */.Rr.subject.pipe((0,distinctUntilChanged/* distinctUntilChanged */.x)()).subscribe( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(value) {
        var _user;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _user = user/* default.getValue */.Z.getValue();

                if (value && (!_user || isEmpty_default()(_user))) {
                  fetchDeliveryMethods(value);
                }

                if (value && _user) {
                  fetchDeliveryMethods(value);
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }());
    return function () {
      isAddressRegistered$.unsubscribe();
      isCheckAddressModal$.unsubscribe();
      postalCode$.unsubscribe();
    };
  }, []);
  var modal = {
    isOpen: isCheckAddressModalOpen,
    closeModal: function closeModal() {
      return store_isAddressRegistered/* IsCheckAddressModal.update */.eR.update(false);
    },
    customStyles: {
      overlay: _objectSpread({}, modalStyle/* default.overlay */.Z.overlay),
      content: _objectSpread(_objectSpread({}, modalStyle/* default.content */.Z.content), {}, {
        width: '33.875rem',
        maxWidth: '100%'
      })
    },
    navigation: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: (DeliveryBanner_module_default()).modalHeader,
      children: "\u0392\u03C1\u03B5\u03C2 \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03AE \u03C4\u03B7\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 \u03C3\u03BF\u03C5"
    }, "checkAddressHeader")],
    view: 'checkAddress',
    body: {
      checkAddress: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Loading"
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckAddressView, {})
      })
    }
  };

  if (isAddressRegistered) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryOptions, {
        selectStore: selectStore
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal, {
        modal: modal
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryPrompt, {
      onClickButton: function onClickButton() {
        return store_isAddressRegistered/* IsCheckAddressModal.update */.eR.update(true);
      }
    }), isCheckAddressModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal, {
        modal: modal
      })
    })]
  });
}

/* harmony default export */ var DeliveryBanner_DeliveryBanner = (DeliveryBanner);

/***/ }),

/***/ 98924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GQ": function() { return /* binding */ SMART; },
/* harmony export */   "JD": function() { return /* binding */ USER_PROFILE; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export ORDER_HISTORY */
var HOMEPAGE = '/';
var USER_PROFILE = '/user';
var ORDER_HISTORY = '/useσr/history';
var OFFERS = '/offers';
var CATEGORIES = '/categories';
var SMART = '/smart';

/***/ }),

/***/ 58345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eH": function() { return /* binding */ CalledProductCategories; },
/* harmony export */   "nv": function() { return /* binding */ ActiveProduct; },
/* harmony export */   "r1": function() { return /* binding */ CalledSuperProductCategories; },
/* harmony export */   "vX": function() { return /* binding */ RenderedProducts; }
/* harmony export */ });
/* unused harmony export ProductsStore */
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20090);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70051);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55709);
/* harmony import */ var _api_Products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16562);





var FETCH_STATUSES = {
  UNFETCHED: 'UNFETCHED',
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
};
var subjectProducts = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X([]);
var statusSub = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(FETCH_STATUSES.UNFETCHED);
var activeProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X('');
var renderedProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X({});
var calledProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var calledSuperProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var ActiveProduct = {
  update: function update(id) {
    activeProduct.next(id);
  },
  subscribe: function subscribe(setState) {
    return activeProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return activeProduct.value;
  }
};
var CalledProductCategories = {
  update: function update(id) {
    calledProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledProductCategories.value;
  }
};
var CalledSuperProductCategories = {
  update: function update(id) {
    calledSuperProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledSuperProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledSuperProductCategories.value;
  }
};
var RenderedProducts = {
  update: function update(products) {
    renderedProduct.next(products);
  },
  subscribe: function subscribe(setState) {
    return renderedProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return renderedProduct.value;
  }
};
var ProductsStore = {
  update: function update(products) {
    statusSub.next(FETCH_STATUSES.FETCHED);
    subjectProducts.next(products);
    return products;
  },
  subscribe: function subscribe(setState) {
    return subjectProducts.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectProducts.value;
  },

  /**
   * If fetching, return when response is ready
   * If fetched, return data from the memory
   * If fetched or (fetched & force update)
   * requests data from server
   * @param {Boolean} forceUpdate
   * @returns products
   */
  getOrFetch: function getOrFetch() {
    var _arguments = arguments;
    return (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var forceUpdate, products;
      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              forceUpdate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

              if (!(statusSub.getValue() === FETCH_STATUSES.FETCHING)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", statusSub.pipe((0,rxjs_operators__WEBPACK_IMPORTED_MODULE_4__/* .skipUntil */ .u)(function (v) {
                return v === FETCH_STATUSES.FETCHED;
              }), (0,rxjs_operators__WEBPACK_IMPORTED_MODULE_5__/* .map */ .U)(function () {
                return subjectProducts.getValue();
              })).toPromise());

            case 3:
              if (!(!forceUpdate && statusSub.getValue() === FETCH_STATUSES.FETCHED)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", ProductsStore.getValue());

            case 5:
              statusSub.next(FETCH_STATUSES.FETCHING);
              _context.next = 8;
              return (0,_api_Products__WEBPACK_IMPORTED_MODULE_1__/* .getProductsWithDetails */ .Hf)();

            case 8:
              products = _context.sent;
              return _context.abrupt("return", ProductsStore.update(products.products));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  ProductsStore: ProductsStore
});

/***/ }),

/***/ 65737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20090);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var serviceOptions$ = new rxjs__WEBPACK_IMPORTED_MODULE_1__/* .BehaviorSubject */ .X({});
var ServiceOptions = {
  update: function update(selectionMade) {
    serviceOptions$.next(selectionMade);
  },
  subscribe: function subscribe(setState) {
    return serviceOptions$.subscribe(setState);
  },
  getValue: function getValue() {
    return serviceOptions$.value;
  },
  setResExpress: function setResExpress(expressTimeslots, expressMessage) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      expressTimeslots: expressTimeslots,
      expressMessage: expressMessage
    }));
  },
  setResEasy: function setResEasy(easyTimeslots, easyMessage) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      easyTimeslots: easyTimeslots,
      easyMessage: easyMessage
    }));
  },
  setResTakeAway: function setResTakeAway(takeAwayTimeslots, takeAwayMessage) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      takeAwayTimeslots: takeAwayTimeslots,
      takeAwayMessage: takeAwayMessage
    }));
  },
  setValidAddressExpress: function setValidAddressExpress(validAddressExpress) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      validAddressExpress: validAddressExpress
    }));
  },
  setValidAddressEasy: function setValidAddressEasy(validAddressEasy) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      validAddressEasy: validAddressEasy
    }));
  },
  setValidTakeAway: function setValidTakeAway(validTakeAway) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      validTakeAway: validTakeAway
    }));
  },
  setCity: function setCity(city) {
    var serviceOptions = ServiceOptions.getValue();
    ServiceOptions.update(_objectSpread(_objectSpread({}, serviceOptions), {}, {
      city: city
    }));
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (ServiceOptions);

/***/ }),

/***/ 81786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ TakeAwayTimeslotsFetched; },
/* harmony export */   "Ku": function() { return /* binding */ ExpressTimeslotsStore; },
/* harmony export */   "dX": function() { return /* binding */ TakeAwayTimeslotsStore; },
/* harmony export */   "sz": function() { return /* binding */ ExpressTimeslotsFetched; }
/* harmony export */ });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var subjectTakeAwayTimeslotsFetched = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectExpressTimeslotsFetched = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var TakeAwayTimeslotsFetched = {
  update: function update(fetched) {
    subjectTakeAwayTimeslotsFetched.next(fetched);
  }
};
var TakeAwayTimeslotsStore = {
  subject: new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X([]),
  update: function update(timeslots) {
    TakeAwayTimeslotsStore.subject.next(timeslots);
    TakeAwayTimeslotsFetched.update(true);
  },
  subscribe: function subscribe(setState) {
    return TakeAwayTimeslotsStore.subject.subscribe(setState);
  },
  getValue: function getValue() {
    return TakeAwayTimeslotsStore.subject.value;
  },
  isFetched: function isFetched() {
    return subjectTakeAwayTimeslotsFetched.value;
  }
};
var ExpressTimeslotsFetched = {
  update: function update(fetched) {
    subjectExpressTimeslotsFetched.next(fetched);
  }
};
var ExpressTimeslotsStore = {
  subject: new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X([]),
  update: function update(timeslots) {
    ExpressTimeslotsStore.subject.next(timeslots);
    ExpressTimeslotsFetched.update(true);
  },
  subscribe: function subscribe(setState) {
    return ExpressTimeslotsStore.subject.subscribe(setState);
  },
  getValue: function getValue() {
    return ExpressTimeslotsStore.subject.value;
  },
  isFetched: function isFetched() {
    return subjectExpressTimeslotsFetched.value;
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  TakeAwayTimeslotsStore: TakeAwayTimeslotsStore,
  ExpressTimeslotsStore: ExpressTimeslotsStore,
  TakeAwayTimeslotsFetched: TakeAwayTimeslotsFetched,
  ExpressTimeslotsFetched: ExpressTimeslotsFetched
});

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 54804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"DeliveryBanner_modalHeader__wjLmy"};

/***/ }),

/***/ 95821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promptContainer":"DeliveryPrompt_promptContainer__WtatU","promptText":"DeliveryPrompt_promptText__G0uu0","icon":"DeliveryPrompt_icon__Oqk7o","btnIcon":"DeliveryPrompt_btnIcon__aEe5p","instruction":"DeliveryPrompt_instruction__ylU9g"};

/***/ })

}]);